// extracted by mini-css-extract-plugin
export default {"modalContainer":"RequestNewCourseModal_modalContainer__YtsDY","title":"RequestNewCourseModal_title__I5ZPT"};